// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.80ab1b4bb',
  revision: '80ab1b4bb',
  branch: 'develop',
  date: 'Fri, 22 May 2026 14:18:19 GMT'
};